var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rounded-lg bg-white mt-2 mx-4 w-[calc(100%-2rem)]" },
    [
      _c(
        "van-form",
        {},
        [
          _c("van-field", {
            staticClass: "px-3",
            attrs: {
              label: _vm.$t("address.phone"),
              placeholder: _vm.$t("address.phoneNumberPlaceholder"),
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "flex-1 flex items-center justify-end" },
                      [
                        _c(
                          "div",
                          [
                            _c("van-field", {
                              staticClass: "p-0",
                              attrs: {
                                placeholder: _vm.$t(
                                  "address.countryCodePlaceholder"
                                ),
                                readonly: "",
                                "is-link": "",
                              },
                              on: {
                                "click-input": function ($event) {
                                  _vm.showCountryCodePopup = true
                                },
                              },
                              model: {
                                value: _vm.form.countryCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "countryCode", $$v)
                                },
                                expression: "form.countryCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("van-field", {
                          staticClass: "p-0 w-44",
                          attrs: {
                            placeholder: _vm.$t(
                              "address.phoneNumberPlaceholder"
                            ),
                          },
                          model: {
                            value: _vm.form.mobile,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mobile", $$v)
                            },
                            expression: "form.mobile",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.form.mobile,
              callback: function ($$v) {
                _vm.$set(_vm.form, "mobile", $$v)
              },
              expression: "form.mobile",
            },
          }),
          _c("van-field", {
            staticClass: "form-field px-3",
            attrs: {
              "label-width": "140px",
              label: _vm.$t("products.emailAddress"),
              placeholder: "XXXX@gmail.com",
            },
            model: {
              value: _vm.form.email,
              callback: function ($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email",
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showCountryCodePopup,
            callback: function ($$v) {
              _vm.showCountryCodePopup = $$v
            },
            expression: "showCountryCodePopup",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.countryCodeList },
            on: {
              confirm: _vm.onCountryCodeConfirm,
              cancel: function ($event) {
                _vm.showCountryCodePopup = false
              },
            },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function (slotProps) {
                  return [
                    _c("div", { staticClass: "flex items-center text-sm" }, [
                      _c("img", {
                        staticClass: "w-5 h-auto",
                        attrs: { src: slotProps.icon, alt: "" },
                      }),
                      _c("span", { staticClass: "ml-3" }, [
                        _vm._v(_vm._s(slotProps.text)),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }